export enum ActionType {
    Manual = 1,
    Auto = 2
}
